import {ContentEditableHtmlEditorPlugin} from '@frontapp/editor-html';

import {surveyImgAttribute} from '../../../../inboxes/composer/signatures/survey';

/*
 * Plugin.
 */

export function createSurveyPlugin(): ContentEditableHtmlEditorPlugin {
  return {
    isImageInteractive: (image) => !image.hasAttribute(surveyImgAttribute),
  };
}
